"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchTableNames = void 0;
/**
 * Shared table names used across batch operations (exports, actions, etc.)
 * This enum provides a centralized definition of database table names
 * to avoid coupling between different batch operation types.
 */
var BatchTableNames;
(function (BatchTableNames) {
    BatchTableNames["Scores"] = "scores";
    BatchTableNames["Sessions"] = "sessions";
    BatchTableNames["Traces"] = "traces";
    BatchTableNames["Observations"] = "observations";
    BatchTableNames["Events"] = "events";
    BatchTableNames["Datasets"] = "datasets";
    BatchTableNames["DatasetRunItems"] = "dataset_run_items";
    BatchTableNames["DatasetItems"] = "dataset_items";
    BatchTableNames["AuditLogs"] = "audit_logs";
})(BatchTableNames || (exports.BatchTableNames = BatchTableNames = {}));
